import React from "react";

import { useContext } from "react";
import { AppContext } from "components/app/RemExprertProvider";
import TextField from "components/ui/controls/text-field/text-field";
import LigneImpotDetaille from "./LigneImpot";
import CardBox from "components/ui/controls/card-box/card-box";
import Column from "components/ui/layout/column/column";
import DropDown from "components/ui/controls/drop-down/drop-down";
import { RemExpertResultatTNS } from "components/app/Api/ResultatRemExpertTNSProvider";
import "./ContexteFiscal.css";

const CapitauxMobiliers = (props) => {
  const { Outil } = props;
  const context = useContext(AppContext);
  const ResultatTNS = useContext(RemExpertResultatTNS);
  console.log(Outil);

  return (
    <div className="revenuspro-container">
      {/* Header séparé */}
      <div className="header-card">
        <div className="category-column">
          <span className="header-icon">💎</span>
          Paramètres des valeurs et capitaux mobiliers
        </div>
        <div className="value-column">
          <span className="header-icon">💰</span>
          Montant
        </div>
      </div>

      {/* Conteneur des cartes de contenu */}
      <div className="card-list-container">
        {/* Application du PFU */}
        <div className="card">
          <div className="category-column">
            <div className="titre-icone">⚙️</div>
            Application du PFU
          </div>
          <div className="value-column">
            <DropDown
              value={context.state[Outil + "OptionPfu"]}
              onChange={context.handleOptionPfu(Outil)}
              options={[
                { value: "oui", label: "Oui" },
                { value: "non", label: "Non" },
              ]}
              normal
            />
          </div>
        </div>

        {/* Dividendes bruts issus des activités soumis aux PS de 18,6% */}
        <div className="card">
          <div className="category-column">
            <div className="titre-icone">📈</div>
            Dividendes bruts issus des activités soumis aux PS de 18,6%
          </div>
          <div className="value-column">
            <TextField
              value={ResultatTNS.state[Outil+"DetailImpot"].AssietteTotaleIR?.DividendeActivitePrelevementSociaux}
              disabled={true}
              dataType="uint"
              format={{ thousands: " ", unit: " €" }}
              normal
            />
          </div>
        </div>

        {/* Dividendes bruts issus des activités non soumis aux PS de 18,6% */}
        <div className="card">
          <div className="category-column">
            <div className="titre-icone">📉</div>
            Dividendes bruts issus des activités non soumis aux PS de 18,6%
          </div>
          <div className="value-column">
            <TextField
              value={Math.max(0,ResultatTNS.state[Outil+"DetailImpot"].DividendeBrutImposable -ResultatTNS.state[Outil+"DetailImpot"].AssietteTotaleIR?.DividendeActivitePrelevementSociaux)}
              disabled={true}
              dataType="uint"
              format={{ thousands: " ", unit: " €" }}
              normal
            />
          </div>
        </div>

        {/* Autres dividendes bruts et actions soumis aux PS de 18,6% */}
        <div className="card">
          <div className="category-column">
            <div className="titre-icone">📊</div>
            Autres dividendes bruts et actions soumis aux PS de 18,6%
          </div>
          <div className="value-column">
            <TextField
              value={context.state[Outil + "IRDirigeantAutreDividendeSoumisPS"]}
              onChange={context.handleInputChange(Outil + "IRDirigeantAutreDividendeSoumisPS")}
              dataType="uint"
              format={{ thousands: " ", unit: " €" }}
              normal
            />
          </div>
        </div>

        {/* Autres dividendes bruts et actions non soumis aux PS de 18,6% */}
        <div className="card">
          <div className="category-column">
            <div className="titre-icone">📋</div>
            Autres dividendes bruts et actions non soumis aux PS de 18,6%
          </div>
          <div className="value-column">
            <TextField
              value={context.state[Outil + "IRDirigeantAutreDividendeNonSoumisPS"]}
              onChange={context.handleInputChange(Outil + "IRDirigeantAutreDividendeNonSoumisPS")}
              dataType="uint"
              format={{ thousands: " ", unit: " €" }}
              normal
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CapitauxMobiliers;
